/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Lessen_BlijvenInputs */

const nl_planning_rooster_lessen_blijven = /** @type {(inputs: Planning_Rooster_Lessen_BlijvenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen die je al hebt ingepland blijven staan.`)
};

/**

* @param {Planning_Rooster_Lessen_BlijvenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_lessen_blijven = /** @type {((inputs?: Planning_Rooster_Lessen_BlijvenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Lessen_BlijvenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_lessen_blijven(inputs)
});
export { planning_rooster_lessen_blijven as "planning.rooster.lessen_blijven" }